import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);
interface ChartDataset {
  label: string;
  data: number[];
  borderColor?: string;
  backgroundColor?: string;
  tension?: number;
  borderWidth?: number;
}
interface ChartBlock {
  title: string;
  subtitle: string;
  data: {
    labels: string[];
    datasets: ChartDataset[];
  };
}
interface SocialChartsProps {
  charts: ChartBlock[];
}
export function SocialCharts({
  charts
}: SocialChartsProps) {
  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(15, 23, 42, 0.9)',
        padding: 12,
        cornerRadius: 8
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: {
            family: 'system-ui, -apple-system, sans-serif',
            size: 11
          }
        }
      },
      y: {
        border: {
          display: false
        },
        grid: {
          color: '#f1f5f9'
        },
        ticks: {
          font: {
            family: 'system-ui, -apple-system, sans-serif'
          }
        }
      }
    }
  };
  return <div className="flex flex-col gap-6" data-id="element-168">
      {charts.map(chart => <div key={chart.title} className="bg-card border border-border rounded-2xl p-6 shadow-sm" data-id="element-169">
          <div className="mb-6" data-id="element-170">
            <h3 className="text-lg font-semibold text-foreground" data-id="element-171">
              {chart.title}
            </h3>
            <p className="text-sm text-muted-foreground mt-1" data-id="element-172">
              {chart.subtitle}
            </p>
          </div>
          <div className="h-[300px] w-full" data-id="element-173">
            <Line options={lineOptions} data={chart.data as any} data-id="element-174" />
          </div>
        </div>)}
    </div>;
}